module.exports = __webpack_public_path__ + "img/13.71b31e94.jpg";